<div class="header">
  <h2 mat-dialog-title>{{ data.title }}</h2>
</div>
<div mat-dialog-content>
  <form class="supportForm" [formGroup]="preferences">
    <mat-label class="label">Requester's Email</mat-label>
    <input
      type="email"
      matInput
      [value]="user.userInfo?.email"
      [disabled]="true"
    >
    <mat-label class="label">Requester's Name</mat-label>
    <input
      type="text"
      matInput
      [value]="user.userInfo?.given_name + ' ' + user.userInfo?.family_name"
      [disabled]="true"
    >
    <mat-label class="label asterix--before">Requester's Team</mat-label>
    <input
      type="text"
      matInput
      formControlName="team"
    >
    <mat-label class="label">Preferred Contact Number</mat-label>
    <input
      type="text"
      matInput
      formControlName="preferredNumber"
    >
    <mat-label class="label asterix--before">Description of issue</mat-label>
    <textarea
      required
      type="text"
      matInput
      formControlName="description"
      cdkTextareaAutosize
      cdkAutosizeMinRows="1"
      cdkAutosizeMaxRows="5"
    ></textarea>
  </form>
</div>
<div
  class="dialog-buttons"
  mat-dialog-actions
  fxLayout="row"
  fxLayoutAlign="end start"
>
  <button
    fxShow="data.confirmText "
    [ngClass]="{'mat-raised-button': true, 'btn-confirm': true}"
    (click)="confirm()"
    [disabled]="!preferences.controls['description'].value || !preferences.controls['team'].value"
  >
    Send Support Request
  </button>
  <button class="mat-raised-button btn-cancel" (click)="cancel()">
    Cancel
  </button>
</div>
